import { atsApiQuery } from '../';

export const offerLetterTemplatesApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllOfferTemplates: builder.query({
        providesTags: ['GetAllOfferTemplates'],
        transformResponse: (response) => response,
        query: ({ params = {} }) => {
          return {
            method: 'get',
            params,
            url: `/ats_offer_templates`,
          };
        },
      }),

      getOfferTemplateById: builder.query({
        providesTags: ['GetOfferTemplateById'],
        transformResponse: (response) => response?.data,
        query: ({ offerTemplateId }) => {
          return {
            method: 'get',
            url: `/ats_offer_templates/${offerTemplateId}`,
          };
        },
      }),

      getSupportedOfferTokens: builder.query({
        providesTags: ['GetSupportedOfferTokens'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/ats_offer_templates/supported_tokens`,
          };
        },
      }),

      createOfferTemplate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            url: '/ats_offer_templates',
            method: 'post',
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetOfferTemplateById' }];
          }
          return [];
        },
      }),

      updateOfferTemplate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, offerTemplateId }) => {
          return {
            url: `/ats_offer_templates/${offerTemplateId}`,
            method: 'put',
            data: payload,
          };
        },
        invalidatesTags: ['GetOfferTemplateById'],
      }),

      deleteOfferTemplate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ offerTemplateId }) => {
          return {
            url: `/ats_offer_templates/${offerTemplateId}`,
            method: 'delete',
          };
        },
        invalidatesTags: ['GetAllOfferTemplates'],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetAllOfferTemplatesQuery,
  useLazyGetAllOfferTemplatesQuery,
  useLazyGetOfferTemplateByIdQuery,
  useCreateOfferTemplateMutation,
  useDeleteOfferTemplateMutation,
  useUpdateOfferTemplateMutation,
  useGetSupportedOfferTokensQuery,
} = offerLetterTemplatesApi;
